<template>
  <footer class="app-footer">
    <a href="http://minsyst.com">MInSysT &copy; Consulting Pvt Ltd. All rights reserved 2019.</a>
    <span class="float-right">Powered by <a href="http://minsyst.com">MInSysT</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue